// Asset API using Dropbox backend via Cloudflare Functions
    const API_BASE = '/api';
    
    const checkConfiguration = () => {
      // For client-side operations, we rely on the server-side functions
      // No client-side configuration needed for Dropbox
      return true;
    };
    
    export const uploadAsset = async (file, folder) => {
      checkConfiguration();
      
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folder', folder || 'documents');
        
        const response = await fetch(`${API_BASE}/upload`, {
          method: 'POST',
          body: formData,
        });
        
        if (!response.ok) {
          const error = await response.text();
          throw new Error(`Upload failed: ${error}`);
        }
        
        const result = await response.json();
        
        if (result.status !== 'success') {
          throw new Error(result.message || 'Upload failed');
        }
        
        return {
          path: result.data.path,
          url: result.data.url,
          name: file.name,
          size: file.size,
          uploaded_at: result.data.uploaded_at,
          bucket: folder || 'documents'
        };
      } catch (error) {
        console.error('Upload failed:', error);
        throw error;
      }
    };
    
    export const listAssets = async (folder) => {
      checkConfiguration();
      
      try {
        const response = await fetch(`${API_BASE}/list-assets?folder=${encodeURIComponent(folder || '')}`);
        
        if (!response.ok) {
          const error = await response.text();
          throw new Error(`List assets failed: ${error}`);
        }
        
        const result = await response.json();
        
        if (result.status !== 'success') {
          throw new Error(result.message || 'Failed to list assets');
        }
        
        return result.data.map(asset => ({
          id: asset.id,
          name: asset.name,
          path: asset.path,
          size: asset.size,
          modified: asset.modified,
          url: asset.url || `${API_BASE}/get-asset?path=${encodeURIComponent(asset.path)}`,
          bucket: folder || 'documents'
        }));
      } catch (error) {
        console.error('List assets failed:', error);
        throw error;
      }
    };
    
    export const getAsset = async (path) => {
      checkConfiguration();
      
      try {
        const response = await fetch(`${API_BASE}/get-asset?path=${encodeURIComponent(path)}`);
        
        if (!response.ok) {
          const error = await response.text();
          throw new Error(`Get asset failed: ${error}`);
        }
        
        // The get-asset endpoint redirects to the actual file
        return response.url;
      } catch (error) {
        console.error('Get asset failed:', error);
        throw error;
      }
    };
    
    export const deleteAsset = async (path) => {
      checkConfiguration();
      
      try {
        const response = await fetch(`${API_BASE}/delete-asset`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ path }),
        });
        
        if (!response.ok) {
          const error = await response.text();
          throw new Error(`Delete failed: ${error}`);
        }
        
        const result = await response.json();
        
        if (result.status !== 'success') {
          throw new Error(result.message || 'Delete failed');
        }
        
        return true;
      } catch (error) {
        console.error('Delete failed:', error);
        throw error;
      }
    };
    
    export const initializeStorage = async () => {
      checkConfiguration();
      
      try {
        const response = await fetch(`${API_BASE}/initialize-storage`, {
          method: 'POST',
        });
        
        if (!response.ok) {
          const error = await response.text();
          throw new Error(`Initialize storage failed: ${error}`);
        }
        
        const result = await response.json();
        
        if (result.status !== 'success') {
          throw new Error(result.message || 'Failed to initialize storage');
        }
        
        return result;
      } catch (error) {
        console.error('Initialize storage failed:', error);
        throw error;
      }
    };